import { render, staticRenderFns } from "./handItems.vue?vue&type=template&id=0aeebb4e"
import script from "./handItems.vue?vue&type=script&lang=js"
export * from "./handItems.vue?vue&type=script&lang=js"
import style0 from "./handItems.vue?vue&type=style&index=0&id=0aeebb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports